import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_5 = { style: {"font-size":"36px","font-weight":"bold"} }
const _hoisted_6 = { style: {"font-size":"36px","font-weight":"bold"} }
const _hoisted_7 = { style: {"font-size":"36px","font-weight":"bold"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_breadcrumbs, {
      class: "px-0",
      items: _ctx.breadcrumbs
    }, null, 8, ["items"]),
    (_ctx.isNew)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("h2", null, "延長保育日誌 新規作成", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.date), 1),
          _createVNode(_component_v_spacer),
          (_ctx.isApplied && (_ctx.isDirector || _ctx.isChief))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateApprovalStatus(true))),
                  disabled: 
            (_ctx.isChief && _ctx.isApprovedByChief) ||
            (_ctx.isDirector && _ctx.isApprovedByDirector)
          ,
                  color: (_ctx.isChief && _ctx.isApprovedByChief) || (_ctx.isDirector && _ctx.isApprovedByDirector) ? 'grey' : 'primary',
                  class: "mr-4",
                  variant: "flat",
                  size: "large"
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("承認", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "color"]),
                (
            (_ctx.isChief && _ctx.isApprovedByChief) ||
            (_ctx.isDirector && _ctx.isApprovedByDirector)
          )
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateApprovalStatus(false))),
                      color: "error",
                      variant: "outlined",
                      size: "large"
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("承認取り消し", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 2,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true),
    (!_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 3,
          class: "mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: "施設長",
                  readonly: "",
                  variant: "outlined",
                  "model-value": _ctx.directorApproveStamp,
                  color: "primary"
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  label: "主任",
                  readonly: "",
                  variant: "outlined",
                  "model-value": _ctx.cheifApproveStamp,
                  color: "primary"
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.staffItems,
                  label: "担当者",
                  multiple: "",
                  "item-title": "name",
                  "item-value": "userId",
                  variant: "outlined",
                  clearable: "",
                  modelValue: _ctx.inputValue.staff,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValue.staff) = $event)),
                  color: "primary"
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.staffItems,
                  label: "申請者",
                  "item-title": "name",
                  "item-value": "userId",
                  variant: "outlined",
                  clearable: "",
                  modelValue: _ctx.inputValue.appliedBy,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValue.appliedBy) = $event)),
                  color: "primary"
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 4 }, {
          default: _withCtx(() => [
            (!_ctx.isNew)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        _cache[17] || (_cache[17] = _createElementVNode("h4", null, "園児人数", -1)),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.diary ? _ctx.diary.totalChildrenCount : ""), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        _cache[18] || (_cache[18] = _createElementVNode("h4", null, "月極", -1)),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.monthlyChildrenCount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        _cache[19] || (_cache[19] = _createElementVNode("h4", null, "スポット", -1)),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.spotChildrenCount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_spacer)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 5,
          class: "d-flex mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "3" }),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: _ctx.watchDate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.watchDate) = $event)),
                  label: "日付",
                  class: "mx-2",
                  type: "date",
                  variant: "outlined",
                  density: "compact"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.staffItems,
                  label: "担当者",
                  multiple: "",
                  "item-title": "name",
                  "item-value": "userId",
                  variant: "outlined",
                  clearable: "",
                  density: "compact",
                  modelValue: _ctx.inputValue.staff,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputValue.staff) = $event))
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  items: _ctx.staffItems,
                  label: "申請者",
                  "item-title": "name",
                  "item-value": "userId",
                  density: "compact",
                  variant: "outlined",
                  clearable: "",
                  modelValue: _ctx.inputValue.appliedBy,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputValue.appliedBy) = $event))
                }, null, 8, ["items", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_container, { class: "pt-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _cache[20] || (_cache[20] = _createElementVNode("h3", null, "活動内容", -1)),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.inputValue.activity,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputValue.activity) = $event)),
                  variant: "outlined",
                  color: "primary"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _cache[21] || (_cache[21] = _createElementVNode("h3", null, "引き継ぎ・伝達事項", -1)),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.inputValue.message,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputValue.message) = $event)),
                  variant: "outlined",
                  color: "primary"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _cache[22] || (_cache[22] = _createElementVNode("h3", null, "備考", -1)),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.inputValue.remarks,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputValue.remarks) = $event)),
                  variant: "outlined",
                  color: "primary"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.isNew && _ctx.diary)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "py-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "8" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, null, {
                      default: _withCtx(() => [
                        _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "text-left" }, "園児氏名"),
                            _createElementVNode("th", { class: "text-left" }, "利用区分"),
                            _createElementVNode("th", { class: "text-left" }, "降園時刻")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diary.children, (childItem, i) => {
                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                              _createElementVNode("td", null, _toDisplayString(childItem.name), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getCategoryName(childItem.category)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(childItem.leftAt)), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isNew)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 6,
          justify: "center",
          class: "mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.createDiary(true))),
              class: "mx-2",
              color: "primary",
              variant: "outlined",
              size: "large"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("下書きとして作成", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.createDiary(false))),
              disabled: !_ctx.inputValue.appliedBy,
              class: "mx-2",
              color: !_ctx.inputValue.appliedBy ? 'grey' : 'primary',
              size: "large",
              variant: "flat"
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("作成して申請", -1)
              ]))]),
              _: 1
            }, 8, ["disabled", "color"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_row, {
          key: 7,
          justify: "center",
          class: "mt-8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateDiary(false))),
              class: "mx-2",
              color: "primary",
              variant: "outlined",
              size: "large"
            }, {
              default: _withCtx(() => [
                (_ctx.isDraft)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "下書きとして保存"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, "差戻し"))
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateDiary(true))),
              disabled: _ctx.inputValue.status === 'applied',
              color: _ctx.inputValue.status === 'applied' ? 'grey' : 'primary',
              class: "mx-2",
              variant: "flat",
              size: "large"
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode("申請", -1)
              ]))]),
              _: 1
            }, 8, ["disabled", "color"])
          ]),
          _: 1
        }))
  ]))
}